<script>
  import { onMount } from 'svelte';
  import { t } from '../i18n/index.js';
  import { showScreen } from '../stores/screen.js';
  import { isLinkMode, clearLinkMode, subscription } from '../stores/session.js';
  import { stopSessionHealthCheck } from '../lib/session-health.js';

  let isFreeUser = $derived($subscription.dailyUploadLimit > 0);
  let remaining = $derived($subscription.dailyUploadLimit - $subscription.dailyUploadsUsed);
  let isLastTransfer = $derived(isFreeUser && remaining <= 0);

  onMount(() => {
    stopSessionHealthCheck();
  });

  function handleDone() {
    clearLinkMode();
    showScreen('landing');
  }
</script>

<div class="screen flex flex-col h-full items-center justify-center p-8">
  <div class="text-center">
    <div class="mb-6">
      <svg class="h-24 w-24 mx-auto text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    </div>
    <h2 class="text-3xl font-bold mb-3">{t('complete.title')}</h2>
    <p class="text-gray-400 text-lg mb-4">{t('complete.message')}</p>

    {#if isFreeUser}
      <div class="remaining-info mb-8">
        {#if isLastTransfer}
          <p class="text-yellow-400 font-medium">{t('upload.lastToday')}</p>
        {:else}
          <p class="text-gray-400">{t('upload.remainingToday', { remaining, limit: $subscription.dailyUploadLimit })}</p>
        {/if}
      </div>
    {:else}
      <div class="mb-8"></div>
    {/if}

    {#if $isLinkMode}
      <div class="flex flex-col gap-4 w-full max-w-xs">
        <button
          onclick={() => showScreen('camera')}
          class="btn-large py-4 px-10 bg-blue-600 hover:bg-blue-500 rounded-xl font-bold text-lg transition-colors"
        >
          {t('link.complete.sendAnother')}
        </button>
        <button
          onclick={handleDone}
          class="btn-large py-4 px-10 bg-gray-600 hover:bg-gray-500 rounded-xl font-bold text-lg transition-colors"
        >
          {t('link.complete.done')}
        </button>
      </div>
    {:else}
      <button
        onclick={() => showScreen('camera')}
        class="btn-large py-4 px-10 bg-blue-600 hover:bg-blue-500 rounded-xl font-bold text-lg transition-colors"
      >
        {t('complete.newScan')}
      </button>
    {/if}
  </div>
</div>

<style>
  .screen {
    display: flex;
  }

  .btn-large {
    min-height: 60px;
    font-size: 1.125rem;
  }
</style>
